function CurrencyExchangeRate(data){
    var self = this;
    self.type = "CurrencyExchangeRate"

    self.currency = ko.observable(data.currency);
    self.exchange_rate = ko.observable(data.exchange_rate);

    self.pretty_exchange_rate = ko.pureComputed(
        () => Intl.NumberFormat('de-DE', { style: 'currency', currency: self.currency() }).format(self.exchange_rate())
    );

};

function PassTheHatPrice(data){
    var self = this;
    self.type = "PlayingForHatPrice"

    self.currency = ko.observable(data.currency);
    self.amount = ko.observable(data.amount);
}

function ProArtistPrice(data){
    var self = this;
    self.type = "ProArtistPrice"

    self.currency = ko.observable(data.currency);
    self.amount = ko.observable(data.amount);
}

export function CurrencyViewModel(data) {

    var self = this;
    self.type = "CurrencyViewModel";

    self.rootvm = data.rootvm;

    self.exchange_rates = ko.observableArray([]);
    self.pass_the_hat_prices = ko.observableArray([]);
    self.pro_artist_prices = ko.observableArray([]);

    self.initialized = ko.observable(false);
    self.initialize = function(){

        if (!self.initialized()){
          self.lookup_prices();
          self.lookup_exchange_rates().then(function(){
                console.log('done looking up currency exchange rates');
                self.initialized(true);
          })};
    }

    self.currency_exchange_rates = ko.observableArray([]);


    self.lookup_exchange_rates = function(){
        self.rootvm.is_busy(true);

        // we need to add in a filter as well..
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/currency-exchange-rates',
            type: 'GET',
            data:{
            },

            contentType: "application/json; charset=utf-8",
            success: function (data) {

                self.exchange_rates(ko.utils.arrayMap( data.exchange_rates|| [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new CurrencyExchangeRate(x);
                    }));

            },
            error: function (data) {
                self.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };

    self.lookup_prices = function(){
        return $.ajax({

            url: self.rootvm.web_host + '/api/lookup-prices',
            type: 'GET',
            data:{
            },

            contentType: "application/json; charset=utf-8",
            success: function (data) {

                console.log(data);

                self.pro_artist_prices(ko.utils.arrayMap( data.pro_artist_prices || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new ProArtistPrice(x);
                    }));

                self.pass_the_hat_prices(ko.utils.arrayMap( data.pass_the_hat_prices || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new PassTheHatPrice(x);
                    }));

            },
            error: function (data) {
                self.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });

    }
};
